import { render, staticRenderFns } from "./OverviewAlerts.vue?vue&type=template&id=d8196148"
import script from "./OverviewAlerts.vue?vue&type=script&lang=js"
export * from "./OverviewAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports